import { useLazyQuery, useQuery } from "@apollo/client";
import { Box, Button, Card, Flex, Heading, Image, Text } from "rebass/styled-components";
import parse, { domToReact, Element } from 'html-react-parser';
import styled from "styled-components";
import { GET_ARTICLE_BY_ID, GET_RANDOM_ARTICLES_WITH_TAG } from "../../../../graphql/queries";
import { IArticle, IGetArticleByIdInput, IGetArticleByIdOutput, IGetArticlesWithTagInput, IGetArticlesWithTagOutput } from "../../../../graphql/types/queries/articles";
import { ArticleCard } from "./Articles";
import { useEffect, useRef } from "react";

const Container = styled(Flex)`
  /* padding-left: 20px;
  padding-right: 20px;
  padding-top: 24px;
  margin-bottom: 64px; */
  @media screen and (max-width: 480px) {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
  }
`;

const Img = styled(Image)`
  transition: 0.3s all ease-in-out;
  object-fit: cover;
  &:hover {
    transform: scale(1.1);
  }
`;

const ArticleCardContainer = styled(Flex)`
  transition: 0.3s all ease-in-out;
  & > * {
    transition: 0.3s all ease-in-out;
  }
  &:hover > * {
    opacity: 0.5;
  }
  &:hover > :hover {
    opacity: 1;
  }
`;

const CardWrap = styled(Card)`
  border-radius: 10px;
  /* margin-right: 20px; */
  flex: initial;
  @media screen and (max-width: 480px) {
    width: 100%;
    max-width: 100vw;
  }
`;

const RelatedPosts = ({ tag, onClick, selectedArticles, onSelect, canSelect = true }: { canSelect?: boolean, tag: string, onClick: (article: IArticle) => void, selectedArticles: Array<IArticle>, onSelect: (article: IArticle) => void }) => {
  const { data, loading, error } = useQuery<IGetArticlesWithTagOutput, IGetArticlesWithTagInput>(GET_RANDOM_ARTICLES_WITH_TAG, {
    variables: {
      limit: 12,
      tag
    }
  })
  if (!!loading) return null;
  if (error || !data || !data.getArticlesWithTag) return null;
  return (
    <ArticleCardContainer flexWrap={'wrap'}>
      {data.getArticlesWithTag.map((x) => {
        return (
          <ArticleCard
            canSelect={canSelect}
            article={x}
            onClick={() => {
              onClick(x)
            }}
            onSelect={() => {
              onSelect(x)
            }}
            isSelected={
              selectedArticles.findIndex(z => z?.id === x.id) > -1
            }
          />
        );
      })}
    </ArticleCardContainer>
  );
};

const ViewArticle = ({ article, selectedArticles, onSelect, onCancel, viewRelatedPost, canSelect = true }: { canSelect?: boolean, viewRelatedPost: (article: IArticle) => void, article: IArticle, selectedArticles: Array<IArticle>, onSelect: (article?: IArticle) => void, onCancel: () => void }) => {
  const [query, { loading, data, error }] = useLazyQuery<IGetArticleByIdOutput, IGetArticleByIdInput>(GET_ARTICLE_BY_ID)
  const containerRef = useRef<any>(null);

  useEffect(() => {
    if (containerRef && containerRef.current) {
      containerRef.current.scrollTo(0, 0);
    }
    if (!!article && !article.content) {
      query({
        variables: {
          id: article.id
        }
      })
    }
  }, [article])

  useEffect(() => {
    if (!!article && !article.content) {
      query({
        variables: {
          id: article.id
        }
      })
    }
  }, [])

  const dta = (data?.getArticleByIdFromWeb?.content || article.content || '')
    .replace(/(<p><\/p>)/g, '')
    .replace(/(<p><br><\/p>)/g, '')
    .replace(/(<p>&nbsp;<\/p>)/g, '')
    .replace(/<[^/>][^>]*><\/[^>]+>/gim, '');

  const prs = parse(dta, {
    replace: (domNode) => {
      console.dir(domNode, { depth: null });
      if (domNode && (domNode as Element).name === 'a') {
        if ((domNode as Element).attribs) {
          if ((domNode as Element).attribs.href && (domNode as Element).attribs.href[0] === '/') {
            return <a href={`/articles/${encodeURIComponent((domNode as Element).attribs.href.replace('/', ''))}`}>{domToReact((domNode as Element).children)}</a>;
          }
        }
      }
    },
  });
  return (
    <Flex flexDirection={'column'} style={{ maxHeight: '100%' }}>

      <Container flexDirection="row" id="cont" overflowY={'auto'} ref={containerRef}>
        <Box flexDirection={'column'} maxWidth='700px' style={{ paddingBottom: '24px' }}>
          <CardWrap>
            <Box style={{ position: 'relative', overflow: 'hidden', width: '100%', height: '290px' }}>
              <Img height={290} width={'100%'} src={article.thumbnailUrl} />
            </Box>
            <Flex flexDirection={'column'} p="44px">
              <Heading mb="36px" textAlign={'center'}>
                {article.title}
              </Heading>
              <>{prs}</>
            </Flex>
          </CardWrap>
          {!!article && article.tag && article.tag.id && (
            <Flex flexDirection={'column'} style={{ padding: '0 24px 24px 24px', marginBottom: '24px' }}>
              <Text fontSize={'16px'} fontWeight={600} mb={3} mt={4}>
                Related Posts
              </Text>
              <RelatedPosts
                canSelect={canSelect}
                selectedArticles={selectedArticles}
                tag={article.tag.id}
                onClick={article => { viewRelatedPost(article) }}
                onSelect={article => onSelect(article)}
              />
            </Flex>
          )}
        </Box>
      </Container>
      <Flex justifyContent={'center'} padding='8px'>
        {!!canSelect ?
          <>
            <Button flex='initial' variant={'primary'} mr={2} onClick={() => onSelect(article)}>{
              selectedArticles.findIndex(x => x.id === article.id) < 0 ? 'Select' : 'Deselect'
            }</Button>
            <Button flex='initial' style={{ width: 'auto' }} variant={'outline'} ml={2} onClick={onCancel}>Cancel</Button>
          </> : (
            <Button flex='initial' style={{ width: 'auto' }} variant={'primary'} ml={2} onClick={onCancel}>Close</Button>
          )}
      </Flex>
    </Flex>
  );
}

export default ViewArticle